export const zhCnLocale = {
  model: {
    product: '产品'
  },
  product: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    desc: '描述',
    title: '标题',
    publishedAt: '发布时间',
    categoryId: '分类',
    designerId: '设计师',
    relatedProductIds: '相关产品',
    cover: '封面',
    wxacode: '小程序码',
    designTime: '设计时间',
    miniProgramPath: '小程序相对路径',
    designer: '设计师',
    category: '分类',
    images: '图片',
    shareImage: '分享图片',
    relatedProducts: '相关产品',
  }
}

export const enLocale = {
  model: {
    product: 'Product'
  },
  product: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    desc: 'Desc',
    title: 'Title',
    publishedAt: 'Published at',
    categoryId: 'Category',
    designerId: 'Designer',
    relatedProductIds: 'Related product ids',
    cover: 'Cover',
    wxacode: 'Wxacode',
    designTime: 'Design time',
    miniProgramPath: 'Mini program path',
    designer: 'Designer',
    category: 'Category',
    images: 'Images',
    shareImage: 'Share image',
    relatedProducts: 'Related products',
  }
}

